import Header from "./components/Header";
import Quote from "./components/Quote";
import Slider from "./components/Slider";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  return (
    <>
      <Header />
      <Quote />
      <Slider />
      <About />
      <Contact />
      <Footer />
    </>
  );
}

export default App;